import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MosaicCellData } from './mosaic-cell.view-model';

@Component({
  selector: 'ts-mosaic-cell',
  templateUrl: './mosaic-cell.component.html',
  styleUrls: ['./mosaic-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MosaicCellComponent {
  @Input() data: MosaicCellData;

  /** A point of interest: placed in the crop, but with no area to draw a frame around. */
  public isPoint(box: NonNullable<MosaicCellData['roiBox']>): boolean {
    return box.widthPercent === 0 && box.heightPercent === 0;
  }

  public get complementaryColor() {
    const { r, g, b, a } = this.rgbaStringToRgb(this.data.color);

    const compR = 255 - r;
    const compG = 255 - g;
    const compB = 255 - b;

    return a !== undefined ? `rgba(${compR}, ${compG}, ${compB}, ${a})` : `rgb(${compR}, ${compG}, ${compB})`;
  }

  public get boxShadow() {
    return this.data.selected
      ? this.data.displayPrimaryColor
        ? '0 0 5px 2px ' + this.complementaryColor
        : '0 0 5px 2px ' + this.data.color
      : 'none';
  }

  public get border() {
    return this.data.selected ? '3px solid ' + this.data.color : 'none';
  }

  public get borderColor() {
    return this.data.displayPrimaryColor ? this.complementaryColor : this.data.color;
  }

  private rgbaStringToRgb(color: string): {
    r: number;
    g: number;
    b: number;
    a?: number;
  } {
    const rgbaMatch = color?.match(/rgba?\((\d+), (\d+), (\d+),?\s*(\d?.\d+)?\)/);

    const [, r, g, b, a] = rgbaMatch ?? [];

    return {
      r: parseInt(r, 10),
      g: parseInt(g, 10),
      b: parseInt(b, 10),
      a: a ? parseFloat(a) : 1,
    };
  }
}
